<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
    >
        <template #layoutContent>
            <div class="card">
                <div class="card card-custom" >
                    <div class="card-header flex-wrap border-0 pt-6 pb-0">
                    <div class="card-title">
                        <h3 class="card-label">{{ $t('brands.list') }}</h3>
                    </div>
                    <div class="card-toolbar">
                        <Button btn-class="btn-sm"v-if="$can(abilities.CREATE_BRAND)" type="new" btn-text="brands.create" @click="openBrandModal"/>
                    </div>
                    </div>
            
                    <div class="card-body" >
                    <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_brands" style="margin-top: 13px !important; cursor:pointer">
                        <thead>
                        <tr class="text-start fw-bold fs-7 text-uppercase gs-0" style="background-color: #F2F3F4;">
                        <th> {{$t("brands.name")}}</th>
                        <th> {{$t("actions")}}</th>
                        </tr>
                        </thead>
                    </table>
                    </div>
                </div>

                <Create id="create" @load="fetchDatas"></Create>
                <Create id="edit" :brand="formUpdateData" @load="fetchDatas"></Create>
            </div>
        </template>
    </SubLayout>
</template>

<script setup>
    import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
    import {nextTick, onMounted, ref, watch} from "vue";
    import i18n from '@/plugins/i18n';
    import Ls from "@/services/ls";
    import {BASE_URL} from "@/services/api";
    import Create from '@/components/Brand/CreateBrand.vue'
    import {useStore} from "vuex";
    import {useHasAbility} from "@/composables/hasAbility";
    import { useLocales } from "@/composables/locales";
    import Button from "@/components/Button.vue"
    import {useSwal} from "@/composables/useSwal";
    import abilities from "@/composables/abilities";
    import {Theme} from "@/composables/theming";

    const title = ref("breadcrumbs.brands.title")
    const breadcrumbs = ref([
        {
            name: 'breadcrumbs.brands.list',
            route: 'brands'
        }
    ])
    const store = useStore()
    const {locale, datatableLocaleUrl} = useLocales()
    const { can } = useHasAbility()
    const {showSwal} = useSwal()

    const table = ref()

    const formUpdateData = ref({
        id:'',
        name: ''
    })

    onMounted(() => {
        fetchDatas()
    })

    watch(() => locale.value, () => {
       nextTick(() => fetchDatas() )
    })

    function fetchDatas() {
        const AUTH_TOKEN = Ls.get('auth.token')
        const pageLimit = Ls.get('pageLength')

        table.value = $("#kt_datatable_brands").DataTable({
            destroy: true,
            responsive: !0,
            searchDelay: 500,
            processing: !0,
            serverSide: !0,
            pageLength: pageLimit ||  5,
            lengthMenu: [5, 10, 25, 50, 75, 100 ],
            order: [[ 0, 'asc']],
            ajax: {
            url: BASE_URL + "/get/brands/datatables",
            type: "GET",
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
              request.setRequestHeader("Company", Ls.get('current.company'));
            }
            },
            columns: [
            { data: "name" },
            { data: "Actions", responsivePriority: -1 }
            ],
            columnDefs: [
            {
                targets: -2,
                orderable:false,
                searchable:false,
                className: "dt-center clickable" ,
                render: function (t) {
                return '<span >' + t + "</span>";
                },
            },
            {
                width: "20%",
                targets: -1,
                "className": "dt-center",
                title: "Actions",
                orderable: !1,
                render: function(t, a, e, l) {
                let render=""
                if(can(abilities.UPDATE_BRAND)){
                    render+='<a data-id="'+ e.id +'" data-name="'+ e.name +'" href="javascript:;" class="btn btn-sm btn-clean btn-icon edit_btn" title="'+ i18n.global.t('button.edit') +'"><i data-id="'+ e.id +'" data-name="'+ e.name +'" class="fas fa-edit fs-2"  style="color: '+Theme.gray +'"></i></a>'
                }
                if(can(abilities.DELETE_BRAND)){
                    render += '<a data-id="'+ e.id +'" data-name="'+ e.name +'" href="javascript:;" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-id="'+ e.id +'" data-name="'+ e.name +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'"></i></a>'
                }
                return render
                },
            },
            ],
            language: {
            url: datatableLocaleUrl.value,
            }
        });

        $(document).on("click", "#kt_datatable_brands .edit_btn", (e) => {
            formUpdateData.value.id = e.target.getAttribute('data-id')
            formUpdateData.value.name = e.target.getAttribute('data-name')
            $('#createBrandModal_edit').modal('toggle')
        });

        $(document).on("click", "#kt_datatable_brands .delete_btn", (e) => {
            let id = e.target.getAttribute('data-id')
            deleteBrand(id)
        });
    }

    function openBrandModal() {
        $('#createBrandModal_create').modal('toggle')
    }

    async function deleteBrand(id) {
        showSwal(
            i18n.global.t('swal.title'),
            i18n.global.t('swal.brands_deleted')
        ).then( async (result) => {
            if (result.value) {
                store.dispatch('brands/deleteBrand', id).then((res) => {
                    table.value.ajax.reload()
                    window.toastr['success'](i18n.global.t('notification.brand_deleted'))
                }).catch(() => {

                })
            }
        })
    }
</script>